import LoginPage from './Login'

export default LoginPage
